import React, {memo, ReactNode} from "react";
import styles from "./VideoMetadataLine.module.css";
import {Video} from "../../video/models/Video";
import clsx from "clsx";
import ViewIcon from "../icons/ViewIcon";
import ReactionIcon from "../icons/ReactionIcon";
import CommentIcon from "../icons/CommentIcon";
import PuiTypography from "../../../components/elements/PuiTypography";
import {TextSize} from "../../../models/element";

interface VideoCommentPanelProps {
    video: Video;
    variant: "normal" | "compact";
    bold?: boolean;
    fontSize?: TextSize;
}

function VideoMetadataLine({variant, video, bold = false, fontSize = 16}: VideoCommentPanelProps) {
    return (
        <div className={styles.line}>

            <MetaItem
                label="views"
                variant={variant}
                count={video.viewCount}
                icon={<ViewIcon size={20} />}
                bold={bold}
                fontSize={fontSize}
            />
            <MetaItem
                label="reactions"
                variant={variant}
                count={video.reactions.length}
                icon={<ReactionIcon size={16} />}
                bold={bold}
                fontSize={fontSize}
            />
            <MetaItem
                label="comments"
                variant={variant}
                count={video.comments.length}
                icon={<CommentIcon size={16} />}
                bold={bold}
                fontSize={fontSize}
            />
        </div>
    );
}

interface MetaItemProps {
    count: number;
    label: string;
    variant: "normal" | "compact";
    icon: ReactNode;
    bold?: boolean;
    fontSize?: TextSize;
}

function MetaItem({count, icon, label, variant, bold = false, fontSize = 16}: MetaItemProps) {
    const classes = clsx(styles.metaItem, {
        [styles.metaItemNormal]: variant === "normal",
        [styles.metaItemCompact]: variant === "compact"
   });

    return (
        <div className={classes}>
            <div className={styles.metaItemIcon}>
                {icon}
            </div>

            {variant === "normal" && (
                <PuiTypography size={fontSize} bold={bold}>{`${label}: ${count}`}</PuiTypography>
            )}

            {variant === "compact" && (
                <PuiTypography size={fontSize} bold={bold}>{`${count}`}</PuiTypography>
            )}
        </div>
    );
}

export default memo(VideoMetadataLine);
